import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Izsilstvo",
  "description": "",
  "published": "2007-05-16T00:00:00.000Z",
  "redirect_from": ["/blog/izsilstvo/swizec/210"],
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`Zakaj se knjige prodajajo s pridatkom izsiljevalskih cen? Sploh obstaja razlaga za ta trend? Res ne vem. Ampak bistvo zadeve je, da so knjige, izdane v Sloveniji, preprosto predrage, da bi jih normalen Älovek sploh upošteval in kupil. Potem se pa Äudimo, da trg s knjigami pada na kamnita tla. Halo!`}</p>
    <p>{`No pa prikaÅ¾imo en primerÄek. Pred nedavnim sem bil prisiljen kupiti slovensko knjigo, ki je sicer bila za pomembno oceno, ampak kakorkoli. Bila je to Pimlico napisana od gospoda Dekleve. Ampak kaj je sedaj to? Koliko me je stala uboga 161 stranska Å¾epnica? 14,56€? Kaj! Še sanja se mi ne. Vem pa, da me je knjiga naroÄena iz amerike, s poštnino, knjigarniško provizijo, lokalnim davkom, priznane avtorice in svetovna uspešnica stala ubogih 7€. ÄŒe vas res zanima je bila to Memnoch the Devil od Anne Rice (434 strani).`}</p>
    <p>{`Zakaj vraga torej obstaja ta razlika, ko je to tako oÄitno perverzno? Knjiga, izdana v mojem lastnem mestu, stane dvakrat toliko kot knjiga z druge strani sveta! Kaj ni nikjer pravice, obÄutka za realnost, ali smo paÄ kot narod tako zabiti, da smo pripravljeni toliko plaÄati za kurÄevo knjigo?`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      